<template>
  <div>
    <OrderList />

  </div>
</template>

<script>
import OrderList from './OrderList/OrderList'

export default {
  name: 'MyOrder',
  components: {
    OrderList,
  },

}
</script>
